export default __webpack_public_path__ + "static/media/Stain-Removers.0f84595d.jpg";